module.exports = __webpack_public_path__ + "img/foto 6.307a7d92.jpg";